// extracted by mini-css-extract-plugin
module.exports = {"link":"_2edl5","image":"_2ztx1","root":"Ued3M"};